module.exports = function() {
  return new Worker(__webpack_public_path__ + "0f9ac05360b4a54bbeed.worker.js");
};